import {products} from "./feature.products.svelte.js";
import {ENTRY_DURATION_2_HOUR, ENTRY_DURATION_DAY, ENTRY_DURATION_EVENING, ENTRY_DURATION_MORNING} from "../../AppConstants";
import AppConfig from "../../AppConfig.js";
import * as products_select from './products.scenarios.select.svelte.js';
import DateTimeUtil from "../../utils/DateTimeUtil.js";

export function getProductByID(iProductID)
{
  iProductID = parseInt(iProductID);
  const aProducts = products.lItems;

  let oFoundProduct = aProducts.find((oProduct) => {
    return oProduct.iID === iProductID;
  });

  return oFoundProduct || false;
}

export function getProductInfoFromAvailableTreatmentsByID(iProductID)
{
  iProductID = parseInt(iProductID);
  const aAvailableTreatments = products.lAvailableTreatments;
// console.log('floep:',$state.snapshot(products));
  if ( !aAvailableTreatments || aAvailableTreatments.length === 0 )
  {
    return false;
  }

  const iSubCatIndex = aAvailableTreatments.findIndex((oSubCat) => {
    return oSubCat.lItems.some((oItem) => oItem.iID === iProductID);
  });

  const oSubCat = aAvailableTreatments[iSubCatIndex];

  if ( oSubCat )
  {
    return oSubCat.lItems.find((oItem) => oItem.iID === iProductID) || false;
  }

  return false;
}

export function getAvailableTimeSlotsForProduct(iProductID, iForXNrOfPeople = 1)
{
  // Bij elke mutatie van de booking wordt booking.oBookingSummary
  // bijgewerkt met daarin oProductPeopleCount
  // Die kunnen we dus veilig gebruiken om te zien wat de actuele stand van zaken is.

  // if ( typeof booking.oBookingSummary.oProductPeopleCount["P" + iProductID] === "undefined" )
  // {
  //   return [];
  // }
  //
  const aResponse = [];
  //
  // const aTimeSlotConfigs = booking.oBookingSummary.oProductPeopleCount["P" + iProductID].aTimeSlots;
  //
  // aTimeSlotConfigs.forEach((oTimeSlotConfig) => {
  //   const sLabel = oTimeSlotConfig.sLabel;
  //   const sValue = oTimeSlotConfig.sValue;
  //   //const iSpotsTotal = oTimeSlotConfig.iSpotsTotal;
  //   const iSpotsLeft = oTimeSlotConfig.iSpotsLeft;
  //
  //   if ( iSpotsLeft >= iForXNrOfPeople )
  //   {
  //     aResponse.push({
  //       sLabel: sLabel,
  //       sValue: sValue
  //     });
  //   }
  // });

  return aResponse;
}

export function areThereSlotsForThisNrOfPeople(iProductID, iOptionalNrOfPeople = 1)
{
  // const aAvailableTimeSlots = products_select.getAvailableTimeSlotsForProduct(iProductID, iOptionalNrOfPeople);
  //
  // if ( aAvailableTimeSlots.length > 0 )
  // {
  //   return true;
  // }

  return false;
}

export function getProductCatForLastProcessedDate(iProductID)
{
  iProductID = parseInt(iProductID);
  const aAvailableProductCategories = products.lAvailableTreatments;
  let iResponse = false;

  if ( aAvailableProductCategories )
  {
    aAvailableProductCategories.forEach((oCategory) => {
      const aItems = oCategory.lItems;
      if ( iResponse === false && aItems )
      {
        aItems.forEach((oItem) => {
          if ( oItem.iID === iProductID )
          {
            iResponse = parseInt(oCategory.sID, 10);
          }
        });
      }
    });
  }

  return iResponse;
}

export function isActionEntryProduct(iProductID)
{
  iProductID = parseInt(iProductID);

  const oProduct = products_select.getProductByID(iProductID);

  if (
    oProduct &&
    oProduct.bIsEntry === true &&
    products.iPreselectedActionEntryProductID !== false &&
    products.iUseThisEntryIDForFirstPerson === iProductID
  )
  {
    return true;
  }

  return false;
}

export function isNonActionEntryProduct(iProductID)
{
  iProductID = parseInt(iProductID);

  const oProduct = products_select.getProductByID(iProductID);

  if (
    oProduct &&
    oProduct.bIsEntry === true &&
    (products.iPreselectedActionEntryProductID === false || products.iUseThisEntryIDForFirstPerson !== iProductID)
  )
  {
    return true;
  }

  return false;
}

export function isEntryProduct(iProductID)
{
  iProductID = parseInt(iProductID);
  const oProduct = getProductByID(iProductID);
//console.log('isEntryProduct', iProductID, oProduct.bIsEntry, $state.snapshot(booker.aAllowedPaymentMethods));
  return oProduct && oProduct.bIsEntry === true;
}

export function isTreatmentProduct(iProductID)
{
  iProductID = parseInt(iProductID);
  const oProduct = getProductByID(iProductID);
  return oProduct && oProduct.bIsTreatment === true;
}

export function isInsuranceProduct(iProductID)
{
  iProductID = parseInt(iProductID);

  // zie ook getAppropriateInsuranceProductID
  const aInsuranceProductIDs = [61, 62, 63, 64, 65, 66, 67, 68, 69];

  return aInsuranceProductIDs.includes(iProductID);
}

export function getEntryType(iProductID = false)
{
  iProductID = parseInt(iProductID);
  if ( !iProductID || !isEntryProduct(iProductID) ) return false;

  if ( AppConfig.aEntreeAvondExternalIDs.includes(iProductID) )
  {
    return ENTRY_DURATION_EVENING;
  }

  if ( AppConfig.aEntreeOchtendExternalIDs.includes(iProductID) )
  {
    return ENTRY_DURATION_MORNING;
  }

  if ( iProductID === AppConfig.iEntree2uurExternalID )
  {
    return ENTRY_DURATION_2_HOUR;
  }

  return ENTRY_DURATION_DAY;
}

export function correctPriceIfProductHasAGodModePriceOverWriteForThisDay(iProductID, iInputPriceCents, sDate)
{
  if ( !sDate )
  {
    return;
  }
  let aTempDateParts = sDate.split('-');
  let iYear = parseInt(aTempDateParts[2]);

  if ( iProductID === 9999999999
    && iYear === 2020
    && sDate !== "01-01-2020"
    && sDate !== "02-01-2020"
    && sDate !== "03-01-2020"
    && sDate !== "04-01-2020"
    && sDate !== "05-01-2020" )
  {
    return 550;
  }

  return iInputPriceCents;
}

export function getSpecialExceptionPriceForProductForDate(iProductID, iInputBasePriceCents, sDate)
{
  iProductID = parseInt(iProductID);
  let iAlternatePriceForThisDay = false;

  const oDate = DateTimeUtil.getDateFromString(sDate);
  if ( !oDate ) return false;

  let bDateIsWeekend = oDate.getDay() === 0 || oDate.getDay() === 6;

  //const aAlternateProductPrices = AppConfig.aAlternateProductPrices;
  const aAlternateProductPrices = [];

  // todo - hier moet het mechanisme komen met de dagprijzen van entrees


  return iInputBasePriceCents;
}

